/**
 * Formatar telefones celulares
 */
import Vue from "vue";
Vue.filter("filterPhone", function(phone) {
  return phone
    .replace(/[^0-9]/g, "")
    .replace(/(\d{2})(\d{5})(\d{4})/, "($1)$2-$3");
});
